import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      id: _ctx.mapId,
      class: "map"
    }, null, 8, _hoisted_1),
    _cache[0] || (_cache[0] = _createElementVNode("div", { id: "msg" }, null, -1))
  ]))
}